import { render, staticRenderFns } from "./GeneralCard.vue?vue&type=template&id=70d8ae34&"
import script from "./GeneralCard.vue?vue&type=script&lang=js&"
export * from "./GeneralCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports